export default "__VITE_ASSET__DS$KfE61__"